/* Site-wide page pop-up. Loads the "main" section of a page/blog post and shows it in a dialog. */
(function () {
  var dialog = document.getElementById('UvbPagePopup');
  if (!dialog || typeof dialog.showModal !== 'function') return; // old browsers just follow the link

  var titleEl = dialog.querySelector('#UvbPagePopupTitle');
  var bodyEl = dialog.querySelector('[data-uvb-popup-body]');
  var fullLink = dialog.querySelector('[data-uvb-popup-full]');
  var always = (dialog.dataset.alwaysPaths || '').split(',').map(function (p) { return p.trim().replace(/\/$/, ''); }).filter(Boolean);
  var cache = {};
  var lastTrigger = null;

  function normalise(path) {
    return path.replace(/\/$/, '').toLowerCase();
  }

  function shouldOpen(link) {
    if (link.hasAttribute('data-uvb-vat-open')) return false; // product VAT note has its own pop-up
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (url.hash && normalise(url.pathname) === normalise(window.location.pathname)) return false;
    if (normalise(url.pathname) === normalise(window.location.pathname)) return false; // already on that page
    if (link.hasAttribute('data-uvb-popup')) return url;
    // Sections marked data-uvb-popup-links (e.g. the FAQ) open every page, policy and blog link in the pop-up.
    if (link.closest('[data-uvb-popup-links]') && /^\/(pages|policies|blogs)\//.test(url.pathname)) return url;
    var path = normalise(url.pathname);
    for (var i = 0; i < always.length; i++) {
      if (path === normalise(always[i])) return url;
    }
    return false;
  }

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var title = doc.querySelector('.shopify-policy__title h1, .main-page-title, .article-template__title, main h1, h1');
    var content = doc.querySelector('.shopify-policy__body .rte, .shopify-policy__body, .article-template__content, main .rte, .rte');
    if (!content) return null;
    content.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    });
    content.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    return { title: title ? title.textContent.trim() : '', html: content.innerHTML };
  }

  function load(url) {
    var key = url.pathname;
    if (cache[key]) return Promise.resolve(cache[key]);
    function fullPage() {
      return fetch(url.pathname, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(extract);
    }
    // Policies aren't theme templates, so load them as full pages straight away.
    var request = url.pathname.indexOf('/policies/') === 0
      ? fullPage()
      : fetch(url.pathname + '?section_id=main', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { return extract(html) || fullPage(); })
          .catch(fullPage);
    return request
      .then(function (data) {
        if (!data) throw new Error('No content');
        cache[key] = data;
        return data;
      });
  }

  function open(url, trigger) {
    lastTrigger = trigger;
    titleEl.textContent = trigger.textContent.replace(/[\u2190-\u21FF]/g, '').trim();
    bodyEl.innerHTML = '<p class="uvb-popup__loading">Loading…</p>';
    fullLink.href = url.pathname;
    dialog.showModal();
    document.documentElement.classList.add('uvb-popup-open');
    load(url).then(function (data) {
      if (data.title) titleEl.textContent = data.title;
      bodyEl.innerHTML = data.html;
      bodyEl.scrollTop = 0;
      // Links inside the pop-up that leave the site open in a new tab
      bodyEl.querySelectorAll('a[href]').forEach(function (a) {
        try {
          if (new URL(a.href).origin !== window.location.origin) {
            a.target = '_blank';
            a.rel = 'noopener';
          }
        } catch (e) {}
      });
    }).catch(function () {
      window.location.href = url.href; // fall back to the real page
    });
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('uvb-popup-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog || e.target.closest('[data-uvb-popup-close]')) close();
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('a[href]');
    if (!link || dialog.contains(link)) return;
    var url = shouldOpen(link);
    if (!url) return;
    e.preventDefault();
    open(url, link);
  });
})();
